import { ComQualif } from './com-qualif.model';
import { ArrayClassConverterFactory } from 'src/app/core/services/mapper/data-property.converter';

export class ComJure {
    static jsonMap = {
        id: 'id',
        nom: 'nom',
        mail: 'mail',
        telFixe: 'telFixe',
        telPortable: 'telPortable',
        qualifications: { key: 'comQualifications', converter: new (ArrayClassConverterFactory.build(ComQualif))(), default: () => [] }
    };

    id: number;
    nom: string;
    mail: string;
    telFixe: string;
    telPortable: string;
    qualifications: ComQualif[];

    constructor(data?: Partial<ComJure>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
